import React from 'react';
export const ChevronLeft = () => (
    <svg
        width="20"
        viewBox="0 0 15 24"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2">
        <path
            d="M.651 10.243L10.237.658a2.267 2.267 0 0 1 3.195 0l.801.8a2.266 2.266 0 0 1 0 3.194l-7.315 7.315 7.315 7.315a2.266 2.266 0 0 1 0 3.194l-.801.8a2.265 2.265 0 0 1-3.195 0L.651 13.689a2.24 2.24 0 0 1-.647-1.722 2.248 2.248 0 0 1 .647-1.724z"
            fill="#515151"
            fillRule="nonzero"
        />
    </svg>
);

export const ChevronRight = () => (
    <svg
        width="20"
        viewBox="0 0 15 24"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2">
        <path
            d="M14.24 13.692l-9.586 9.585a2.267 2.267 0 0 1-3.195 0l-.801-.8a2.266 2.266 0 0 1 0-3.194l7.315-7.315L.658 4.653a2.266 2.266 0 0 1 0-3.194l.801-.8a2.265 2.265 0 0 1 3.195 0l9.586 9.587a2.24 2.24 0 0 1 .647 1.722 2.248 2.248 0 0 1-.647 1.724z"
            fill="#515151"
            fillRule="nonzero"
        />
    </svg>
);

export const FolderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        width="20"
        viewBox="0 0 30 20">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M27.527 2.623h-.764V1.99c0-1.101-.898-1.99-2-1.99H14.45c-1.609 0-2.27 1.114-3.4 2.623H2.298A2.31 2.31 0 0 0 0 4.923v12.614a2.304 2.304 0 0 0 2.298 2.294h25.229a2.297 2.297 0 0 0 2.289-2.294V4.922a2.302 2.302 0 0 0-2.289-2.299z"
        />
    </svg>
);

export const SearchIcon = () => (
    <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.227 24.5251L16.9227 25.2932C16.3216 25.4936 15.6699 25.4815 15.0767 25.259L10.3069 23.4704C9.71369 23.2479 9.06204 23.2358 8.46096 23.4362L5.60181 24.3893C3.81065 24.9863 1.96094 23.6531 1.96094 21.7651V6.13487C1.96094 4.94423 2.72282 3.88718 3.85235 3.51067L8.46096 1.97447C9.06204 1.77411 9.71369 1.78617 10.3069 2.00864L15.0767 3.79729C15.6699 4.01976 16.3216 4.03182 16.9227 3.83146L19.7818 2.87841C21.573 2.28136 23.4227 3.61455 23.4227 5.50261V16.1243"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <circle cx="17.6356" cy="18.4296" r="3.61024" stroke="currentColor" strokeWidth="2" />
        <mask id="path-3-inside-1" fill="currentColor">
            <path d="M19.4797 21.5771L20.7837 20.2732L24.0436 23.5331C24.4037 23.8932 24.4037 24.477 24.0436 24.8371C23.6836 25.1972 23.0997 25.1972 22.7397 24.8371L19.4797 21.5771Z" />
        </mask>
        <path
            d="M19.4797 21.5771L18.0655 20.1629L16.6513 21.5771L18.0655 22.9914L19.4797 21.5771ZM20.7837 20.2732L22.1979 18.859L20.7837 17.4447L19.3695 18.859L20.7837 20.2732ZM20.8939 22.9914L22.1979 21.6874L19.3695 18.859L18.0655 20.1629L20.8939 22.9914ZM19.3695 21.6874L22.6294 24.9473L25.4579 22.1189L22.1979 18.859L19.3695 21.6874ZM24.1539 23.4229L20.8939 20.1629L18.0655 22.9914L21.3255 26.2513L24.1539 23.4229ZM22.6294 23.4229C23.0504 23.0019 23.7329 23.0019 24.1539 23.4229L21.3255 26.2513C22.4666 27.3924 24.3167 27.3924 25.4579 26.2513L22.6294 23.4229ZM22.6294 24.9473C22.2085 24.5264 22.2085 23.8438 22.6294 23.4229L25.4579 26.2513C26.599 25.1102 26.599 23.26 25.4579 22.1189L22.6294 24.9473Z"
            fill="currentColor"
            mask="url(#path-3-inside-1)"
        />
        <line
            x1="9.75"
            y1="4.58252"
            x2="9.75"
            y2="20.0825"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="1.5 4"
        />
        <line
            x1="17.75"
            y1="6.58252"
            x2="17.75"
            y2="11.0825"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="1.5 4"
        />
    </svg>
);

export const MapTypeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        width="20"
        viewBox="0 0 14 11">
        <g fill="currentColor">
            <path d="M2.798.625a.704.704 0 0 0-.776-.621L.625.159a.704.704 0 0 0-.621.776l.819 7.379a.703.703 0 0 0 .776.62l1.397-.155a.702.702 0 0 0 .621-.775L2.798.625z" />
            <path d="M10.647 1.535l.688 8.836-8.081-1.687L2.332.052l8.315 1.483zM4.286 7.75l5.811 1.213-.504-6.473L3.61 1.422l.676 6.328z" />
            <path d="M12.812 1.999a.7.7 0 0 0-.773-.618l-1.392.154a.7.7 0 0 0-.618.773l.831 7.49a.7.7 0 0 0 .773.618l1.392-.154a.7.7 0 0 0 .618-.773l-.831-7.49z" />
        </g>
    </svg>
);

export const PlanningIcon = () => (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 3.00049H4C2.34315 3.00049 1 4.34363 1 6.00049V22.0005C1 23.6573 2.34315 25.0005 4 25.0005H20C21.6569 25.0005 23 23.6573 23 22.0005V6.00049C23 4.34363 21.6569 3.00049 20 3.00049H19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <rect
            x="8"
            y="1.00049"
            width="8"
            height="5"
            rx="2"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
        />
        <line
            x1="7.92725"
            y1="15.7343"
            x2="11.0297"
            y2="17.5255"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <path d="M14 17.0005L17 13.0005" stroke="currentColor" strokeWidth="1.5" />
        <circle
            r="1.79122"
            transform="matrix(-0.866025 -0.5 -0.5 0.866025 12.5048 18.5536)"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <circle
            r="1.79122"
            transform="matrix(-0.866025 -0.5 -0.5 0.866025 6.29973 14.9711)"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <circle
            r="1.79122"
            transform="matrix(-0.866025 -0.5 -0.5 0.866025 18.4169 11.4471)"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export const LayersIcon = () => (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.5299 10.6562C22.5071 10.641 22.4835 10.6269 22.4593 10.614L20.8548 9.75L11.9572 14.4608C11.7209 14.586 11.4378 14.586 11.2015 14.4608L2.30393 9.75L0.699447 10.614C0.309493 10.821 0.161119 11.3049 0.368114 11.6948C0.380983 11.7191 0.395082 11.7426 0.410364 11.7654L11.5794 17.6786L22.7484 11.7654C22.9943 11.3988 22.8965 10.9022 22.5299 10.6562Z"
            fill="currentColor"
        />
        <path
            d="M22.7864 15.7862C22.7116 15.6476 22.5979 15.534 22.4594 15.4592L20.8549 14.5952L11.9573 19.306C11.721 19.4312 11.4379 19.4312 11.2016 19.306L2.30396 14.5952L0.699481 15.4592C0.30702 15.671 0.160633 16.1609 0.372454 16.5533C0.447256 16.6919 0.560949 16.8056 0.699481 16.8803L11.1967 22.5327C11.4356 22.6613 11.7232 22.6613 11.9622 22.5327L22.4594 16.8803C22.8518 16.6685 22.9982 16.1787 22.7864 15.7862Z"
            fill="currentColor"
        />
        <path
            d="M22.5299 5.81207C22.5071 5.79679 22.4835 5.78269 22.4593 5.76982L11.9621 0.117479C11.7232 -0.0111649 11.4356 -0.0111649 11.1966 0.117479L0.699447 5.76982C0.309493 5.97682 0.161119 6.46074 0.368114 6.85069C0.380983 6.87491 0.395082 6.89848 0.410364 6.92128L11.5794 12.8344L22.7484 6.92128C22.9943 6.55465 22.8965 6.05805 22.5299 5.81207Z"
            fill="currentColor"
        />
    </svg>
);

export const PlaceIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        width="16"
        viewBox="0 0 21 27">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M20.961 10.481C20.961 4.692 16.269 0 10.481 0 4.692 0 0 4.692 0 10.481a10.5 10.5 0 0 0 .433 2.983c1.492 6.035 10.095 12.785 10.095 12.785s9.719-7.621 10.291-13.91l-.025-.005c.108-.601.167-1.22.167-1.853zm-10.337 2.334a4.288 4.288 0 1 1 0-8.577 4.288 4.288 0 0 1 0 8.577z"
        />
    </svg>
);

export const GBPIcon = () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="12"
            cy="12.4165"
            r="11"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M8.25 13.8441V16.1303H7V18.4165H17V16.1303H10.75V13.8441H14.5V11.558H10.75V10.4149C10.7497 10.0446 10.8804 9.68426 11.1227 9.38762C11.365 9.09098 11.7057 8.87401 12.094 8.76916C12.4823 8.66431 12.8973 8.6772 13.2769 8.80592C13.6565 8.93464 13.9803 9.17226 14.2 9.48326L16.6825 8.91629C16.3015 8.05588 15.6052 7.34336 14.7129 6.90074C13.8206 6.45812 12.7879 6.31292 11.7914 6.49001C10.7949 6.66709 9.89679 7.15545 9.25073 7.87146C8.60468 8.58747 8.25091 9.48659 8.25 10.4149V11.558H7V13.8441H8.25Z"
            fill="currentColor"
        />
    </svg>
);

export const AnalysesIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeMiterlimit="1.5"
        clipRule="evenodd"
        width="20"
        viewBox="0 0 13 12">
        <g fill="none" stroke="currentColor" strokeWidth="2.25">
            <path d="M2.028 2.028h8.861M2.028 5.778h5.907M2.028 9.528h2.954" />
        </g>
    </svg>
);

export const BookmarkIcon = () => (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.5793 18.8145H3.57935C2.47478 18.8145 1.57935 19.7099 1.57935 20.8145V20.8145C1.57935 21.919 2.47478 22.8145 3.57935 22.8145H19.5793"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <path
            d="M19.5793 18.8145V2.81445C19.5793 1.70988 18.6839 0.814453 17.5793 0.814453H3.57935C2.47478 0.814453 1.57935 1.70988 1.57935 2.81445V20.3145"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <path d="M12.5793 3.81445H14.5793V9.81445L12.5793 10.8145V3.81445Z" fill="currentColor" />
        <path d="M16.5793 3.81445H14.5793V9.81445L16.5793 10.8145V3.81445Z" fill="currentColor" />
    </svg>
);

export const PrintIcon = () => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.50792 20H4.57934C2.92249 20 1.57935 18.6569 1.57935 17V9C1.57935 7.34315 2.92249 6 4.57935 6H20.5793C22.2362 6 23.5793 7.34315 23.5793 9V17C23.5793 18.6569 22.2362 20 20.5793 20H19.6508"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <mask id="path-2-inside-1" fill="white">
            <path d="M4.57935 1C4.57935 0.447715 5.02706 0 5.57935 0H19.5793C20.1316 0 20.5793 0.447715 20.5793 1V7H4.57935V1Z" />
        </mask>
        <path
            d="M4.57935 1C4.57935 0.447715 5.02706 0 5.57935 0H19.5793C20.1316 0 20.5793 0.447715 20.5793 1V7H4.57935V1Z"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            mask="url(#path-2-inside-1)"
        />
        <mask id="path-3-inside-2" fill="white">
            <rect x="4.57935" y="15" width="16" height="9" rx="1" />
        </mask>
        <rect
            x="4.57935"
            y="15"
            width="16"
            height="9"
            rx="1"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            mask="url(#path-3-inside-2)"
        />
        <line
            x1="17.5793"
            y1="10"
            x2="19.5793"
            y2="10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="bevel"
        />
    </svg>
);

export const AutocompleteSearchIcon = () => (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 10.5C7.40666 10.5 6.82664 10.3241 6.33329 9.99441C5.83994 9.66477 5.45543 9.19623 5.22836 8.64805C5.0013 8.09987 4.94189 7.49667 5.05765 6.91473C5.1734 6.33279 5.45912 5.79824 5.87868 5.37868C6.29824 4.95912 6.83279 4.6734 7.41473 4.55765C7.99667 4.44189 8.59987 4.5013 9.14805 4.72836C9.69623 4.95543 10.1648 5.33994 10.4944 5.83329C10.8241 6.32664 11 6.90666 11 7.5C10.999 8.29536 10.6827 9.05787 10.1203 9.62027C9.55787 10.1827 8.79536 10.499 8 10.5ZM8 5.7C7.64399 5.7 7.29598 5.80557 6.99997 6.00336C6.70397 6.20114 6.47326 6.48226 6.33702 6.81117C6.20078 7.14008 6.16513 7.502 6.23459 7.85116C6.30404 8.20033 6.47547 8.52106 6.72721 8.77279C6.97894 9.02453 7.29967 9.19596 7.64884 9.26541C7.998 9.33487 8.35992 9.29922 8.68883 9.16298C9.01774 9.02675 9.29886 8.79604 9.49665 8.50003C9.69443 8.20402 9.8 7.85601 9.8 7.5C9.79952 7.02276 9.60973 6.5652 9.27227 6.22774C8.9348 5.89027 8.47724 5.70048 8 5.7Z"
            fill="currentColor"
        />
        <path
            d="M8 18L2.24819 11.6042C2.16827 11.5082 2.08917 11.4115 2.01092 11.3143C1.0284 10.094 0.497626 8.6035 0.500008 7.07143C0.500008 5.19597 1.29018 3.39732 2.6967 2.07117C4.10323 0.745024 6.01088 0 8 0C9.98912 0 11.8968 0.745024 13.3033 2.07117C14.7098 3.39732 15.5 5.19597 15.5 7.07143C15.5024 8.60281 14.9718 10.0926 13.9898 11.3124L13.9891 11.3143C13.9891 11.3143 13.7845 11.5676 13.7539 11.6016L8 18ZM3.0991 10.5396C3.10046 10.5396 3.25864 10.7376 3.29478 10.7801L8 16.0123L12.7114 10.773C12.7414 10.7376 12.9009 10.5384 12.9016 10.5377C13.7042 9.54072 14.1379 8.32309 14.1364 7.07143C14.1364 5.53696 13.4898 4.06534 12.3391 2.98031C11.1883 1.89528 9.62746 1.28571 8 1.28571C6.37254 1.28571 4.81173 1.89528 3.66094 2.98031C2.51015 4.06534 1.86364 5.53696 1.86364 7.07143C1.86221 8.32387 2.29644 9.54219 3.09978 10.5396H3.0991Z"
            fill="currentColor"
        />
    </svg>
);

export const CloseIcon = () => (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="1.30413"
            y="1.78508"
            width="13.4983"
            height="14.4297"
            rx="0.848805"
            stroke="currentColor"
            strokeWidth="1.69761"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.8727 7.32636C11.2002 6.99092 11.2002 6.44707 10.8727 6.11162C10.5453 5.77618 10.0143 5.77618 9.68685 6.11162L10.8727 7.32636ZM5.23379 10.6731C4.90632 11.0086 4.90632 11.5524 5.23379 11.8879C5.56126 12.2233 6.09219 12.2233 6.41966 11.8879L5.23379 10.6731ZM9.68685 6.11162L5.23379 10.6731L6.41966 11.8879L10.8727 7.32636L9.68685 6.11162Z"
            fill="currentColor"
        />
        <path
            d="M9.60921 11.8083C9.93668 12.1437 10.4676 12.1437 10.7951 11.8083C11.1226 11.4729 11.1226 10.929 10.7951 10.5936L9.60921 11.8083ZM6.49703 6.19086C6.16956 5.85541 5.63863 5.85541 5.31116 6.19086C4.98369 6.5263 4.98369 7.07016 5.31116 7.4056L6.49703 6.19086ZM10.7951 10.5936L6.49703 6.19086L5.31116 7.4056L9.60921 11.8083L10.7951 10.5936Z"
            fill="currentColor"
        />
    </svg>
);

export const CloseSecondaryIcon = () => (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8727 7.32636C11.2002 6.99092 11.2002 6.44707 10.8727 6.11162C10.5453 5.77618 10.0143 5.77618 9.68685 6.11162L10.8727 7.32636ZM5.23379 10.6731C4.90632 11.0086 4.90632 11.5524 5.23379 11.8879C5.56126 12.2233 6.09219 12.2233 6.41966 11.8879L5.23379 10.6731ZM9.68685 6.11162L5.23379 10.6731L6.41966 11.8879L10.8727 7.32636L9.68685 6.11162Z"
            fill="currentColor"
        />
        <path
            d="M9.60921 11.8083C9.93668 12.1437 10.4676 12.1437 10.7951 11.8083C11.1226 11.4729 11.1226 10.929 10.7951 10.5936L9.60921 11.8083ZM6.49703 6.19086C6.16956 5.85541 5.63863 5.85541 5.31116 6.19086C4.98369 6.5263 4.98369 7.07016 5.31116 7.4056L6.49703 6.19086ZM10.7951 10.5936L6.49703 6.19086L5.31116 7.4056L9.60921 11.8083L10.7951 10.5936Z"
            fill="currentColor"
        />
    </svg>
);

export const PDFIcon = () => (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.1753 6.30046H10.712C10.4752 6.30046 10.2482 6.21864 10.0808 6.073C9.91338 5.92735 9.81934 5.72982 9.81934 5.52385V1.6408C9.82022 1.48748 9.87324 1.33781 9.97173 1.21067C10.0702 1.08352 10.2098 0.984582 10.3728 0.926321C10.5353 0.866849 10.7145 0.8506 10.8877 0.879625C11.0608 0.90865 11.2202 0.981648 11.3458 1.08941L15.809 4.97246C15.9329 5.08167 16.0168 5.22035 16.0502 5.371C16.0835 5.52166 16.0649 5.67753 15.9965 5.81896C15.9295 5.96078 15.8158 6.08219 15.6697 6.16788C15.5235 6.25356 15.3515 6.29969 15.1753 6.30046ZM11.6046 4.74724H13.024L11.6046 3.51243V4.74724Z"
            fill="white"
        />
        <path
            d="M10.819 12.6066C10.7015 12.6072 10.5851 12.5876 10.4763 12.549C10.3676 12.5103 10.2686 12.4534 10.1852 12.3814L8.03393 10.502L5.88263 12.3814C5.7994 12.4538 5.70059 12.5112 5.59185 12.5504C5.4831 12.5896 5.36655 12.6098 5.24885 12.6098C5.13114 12.6098 5.01459 12.5896 4.90584 12.5504C4.7971 12.5112 4.69829 12.4538 4.61506 12.3814C4.53183 12.309 4.46581 12.223 4.42077 12.1284C4.37572 12.0338 4.35254 11.9324 4.35254 11.83C4.35254 11.7276 4.37572 11.6262 4.42077 11.5316C4.46581 11.437 4.53183 11.351 4.61506 11.2786L7.40014 8.85557C7.48313 8.78278 7.58186 8.72501 7.69063 8.68558C7.79941 8.64615 7.91609 8.62585 8.03393 8.62585C8.15177 8.62585 8.26844 8.64615 8.37722 8.68558C8.486 8.72501 8.58473 8.78278 8.66771 8.85557L11.4528 11.2786C11.5365 11.3508 11.6029 11.4367 11.6482 11.5313C11.6935 11.626 11.7168 11.7275 11.7168 11.83C11.7168 11.9325 11.6935 12.034 11.6482 12.1287C11.6029 12.2233 11.5365 12.3092 11.4528 12.3814C11.3694 12.4534 11.2705 12.5103 11.1617 12.549C11.0529 12.5876 10.9365 12.6072 10.819 12.6066Z"
            fill="white"
        />
        <path
            d="M15.1751 19.503H10.7119C10.4751 19.503 10.2481 19.4212 10.0807 19.2756C9.91325 19.1299 9.8192 18.9324 9.8192 18.7264C9.8192 18.5204 9.91325 18.3229 10.0807 18.1773C10.2481 18.0316 10.4751 17.9498 10.7119 17.9498H14.2825V5.84246L10.3459 2.41761H1.78531V17.9498H6.24858C6.48533 17.9498 6.71238 17.868 6.87978 17.7223C7.04719 17.5767 7.14124 17.3792 7.14124 17.1732V9.4071C7.14124 9.20113 7.23528 9.0036 7.40269 8.85795C7.57009 8.71231 7.79714 8.63049 8.03389 8.63049C8.27064 8.63049 8.49769 8.71231 8.66509 8.85795C8.8325 9.0036 8.92655 9.20113 8.92655 9.4071V17.1732C8.92655 17.7911 8.6444 18.3837 8.14219 18.8206C7.63997 19.2576 6.95882 19.503 6.24858 19.503H0.892655C0.655908 19.503 0.428858 19.4212 0.261452 19.2756C0.0940472 19.1299 0 18.9324 0 18.7264V1.641C0 1.43503 0.0940472 1.2375 0.261452 1.09186C0.428858 0.946214 0.655908 0.864393 0.892655 0.864393H10.7119C10.8293 0.863802 10.9458 0.883392 11.0546 0.92204C11.1633 0.960687 11.2622 1.01763 11.3456 1.08961L15.8089 4.97266C15.8916 5.04522 15.9571 5.13128 16.0015 5.2259C16.0459 5.32053 16.0685 5.42184 16.0678 5.52405V18.7264C16.0678 18.9324 15.9737 19.1299 15.8063 19.2756C15.6389 19.4212 15.4119 19.503 15.1751 19.503Z"
            fill="white"
        />
    </svg>
);

export const UploadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_8738_113793)">
            <path
                d="M5.9987 10.6667H9.9987V6.66667H12.6654L7.9987 2L3.33203 6.66667H5.9987V10.6667ZM3.33203 12H12.6654V13.3333H3.33203V12Z"
                fill="#A9FE95"
            />
        </g>
        <defs>
            <clipPath id="clip0_8738_113793">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
